/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const OLMoE = ({ color = 'primary', aspectRatio = '773/133', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="OLMoE" aspectRatio={aspectRatio} color={color} {...rest} />;

export { OLMoE, OLMoE as default };
